import { Link, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider.js";
import { ThemeToggle } from "../components/index.js";
import { pageTitleForPath } from "./nav.js";

/**
 * Cabeçalho (Design.md §4): 60px, fundo `--navy` — título da página, busca
 * global, alternador de tema e sino de notificações. Busca e sino são visuais
 * nesta entrega (PR-1); a função vem com as telas (PR-2+). Configurações (§10.2,
 * ADMIN-only) não está no menu §4.1 — entra aqui como engrenagem.
 */
export function Header(): ReactNode {
  const location = useLocation();
  const title = pageTitleForPath(location.pathname);
  const { me } = useAuth();

  return (
    <header
      style={{
        height: 60,
        flex: "0 0 60px",
        background: "var(--navy)",
        color: "var(--nav-text)",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        padding: "0 1.25rem",
        position: "sticky",
        top: 0,
        zIndex: 10
      }}
    >
      <h1 style={{ fontSize: 21, fontWeight: 700, margin: 0 }}>{title}</h1>

      <div style={{ flex: 1 }} />

      <input
        type="search"
        placeholder="Pesquisar…"
        aria-label="Busca global"
        style={{
          width: 240,
          maxWidth: "32vw",
          background: "rgba(255,255,255,0.1)",
          border: "1px solid rgba(255,255,255,0.18)",
          color: "var(--nav-text)",
          borderRadius: 8,
          padding: "0.45rem 0.7rem",
          fontSize: 12.5
        }}
      />

      <ThemeToggle />

      {me?.role === "ADMIN" ? (
        <Link
          to="/configuracoes"
          aria-label="Configurações"
          title="Configurações"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "transparent",
            border: "1px solid var(--nav-text-muted)",
            color: "var(--nav-text)",
            borderRadius: 8,
            // Alvo de toque ≥44px (§11).
            minWidth: 44,
            minHeight: 44,
            padding: "0 0.6rem",
            fontSize: 14,
            textDecoration: "none"
          }}
        >
          <span aria-hidden>⚙️</span>
        </Link>
      ) : null}

      <button
        type="button"
        aria-label="Notificações"
        title="Notificações"
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          background: "transparent",
          border: "1px solid var(--nav-text-muted)",
          color: "var(--nav-text)",
          borderRadius: 8,
          // Alvo de toque ≥44px (§11).
          minWidth: 44,
          minHeight: 44,
          padding: "0 0.6rem",
          fontSize: 14,
          cursor: "pointer"
        }}
      >
        <span aria-hidden>🔔</span>
      </button>
    </header>
  );
}
